<template>
  <b-container>
 <h3>Comment jouez vous</h3>
<b-form-group
    label="A quel moment pouvez vous jouer ?"
  >
<b-form-radio-group       @input="$v.when.$touch()"
                          v-model="when"
                          stacked
                          name="when">
        <b-form-radio value="dayBefore">La veille des courses exclusivement</b-form-radio>
        <b-form-radio value="morning">Le jour de la course, le matin</b-form-radio>
        <b-form-radio value="manyTimes">A plusieurs moment de la journée, entre les courses</b-form-radio>
        <b-form-radio value="lastMinute">A la dernière minutes, en suivant les courses en direct</b-form-radio>
      </b-form-radio-group>
  </b-form-group>

<b-form-group
    label="Combien de fois par semaine jouez vous ?"
  >
<b-form-radio-group
                          v-model="timesPerWeek"
                          stacked
                          name="timesPerWeek">
        <b-form-radio value="everyDay">Tous les jours</b-form-radio>
        <b-form-radio value="several">Quelques fois dans la semaine</b-form-radio>
        <b-form-radio value="weekend">Les week ends uniquement</b-form-radio>
        <b-form-radio value="lessThanOnce">Occasionnellement (moins d'une fois par semaine)</b-form-radio>
        <b-form-radio value="never">Jamais</b-form-radio>
      </b-form-radio-group>
  </b-form-group>


  <b-form-group
    label="Quels sont vos jeux préférés ?"

  >


 <b-form-checkbox-group @input="$v.favoriteBets.$touch()" stacked id="favoriteBets" name="favoriteBets" v-model="favoriteBets" :class="{ error: $v.favoriteBets.$error }">

        <b-form-checkbox value="simple">Jeu Simple</b-form-checkbox>
        <b-form-checkbox value="couple">Couplé</b-form-checkbox>
        <b-form-checkbox value="trio">Trio</b-form-checkbox>
        <b-form-checkbox value="multi">Multi</b-form-checkbox>
        <b-form-checkbox value="top5">Top5</b-form-checkbox>
        <b-form-checkbox value="tqq">Tiercé / Quarté / Quinté</b-form-checkbox>
        <b-form-checkbox value="none">Aucun</b-form-checkbox>

      </b-form-checkbox-group >

      </b-form-group>
    <b-form-group class="action">
  <div class="float-left">   <b-button variant="outline-primary" to="/section2">&lt; Précédent</b-button></div>
  <div class="float-right"><b-button variant="outline-primary" to="/answer" :disabled="$v.$invalid">Suivant &gt;</b-button></div>


</b-form-group>
  </b-container>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import { required } from 'vuelidate/lib/validators'
  export default {
    name: 'section3',

 validations: {

      timesPerWeek: { required },
      when: { required },
      favoriteBets: { required },

  },

    computed: {
    // When using nested data structures, the string
    // after the last dot (e.g. `firstName`) is used
    // for defining the name of the computed property.
    ...mapFields([
      'answers.when',
      'answers.timesPerWeek',
      'answers.operator',
      'answers.favoriteBets',
    ]),
  },

  }
</script>

<style scoped>

</style>